import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/theme-dark.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { RecoilRoot } from 'recoil';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';
import App from './App';
import ContextProvider from './contexts';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

if (import.meta.hot) {
  import.meta.hot.accept();
}
TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(en);
const queryClient = new QueryClient();

// @ts-ignore
BigInt.prototype['toJSON'] = function () {
  return this.toString();
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <HashRouter basename={"/"}>
      <SWRConfig>
        <RecoilRoot>
          <ContextProvider>
            <App />
          </ContextProvider>
        </RecoilRoot>
      </SWRConfig>
    </HashRouter>
  </QueryClientProvider>
);
